var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.59,
    height: 24.622,
    viewBox: "0 0 30.59 24.622",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-home-1560062",
    transform: "translate(-120.401 -95.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32485",
    "data-name": "Path 32485",
    d: "M135.694,95.2a1.308,1.308,0,0,0-.688.233l-14.176,11.191a1.336,1.336,0,0,0-.245,1.62,1.159,1.159,0,0,0,1.62.14l13.488-10.643,13.488,10.643a1.146,1.146,0,0,0,1.62-.14,1.27,1.27,0,0,0-.245-1.62L136.382,95.434a1.139,1.139,0,0,0-.688-.233Zm-8.953,10.924L124.5,107.9V118.7h0a1.119,1.119,0,0,0,1.119,1.119h7.088a1.119,1.119,0,0,0,1.119-1.119v-4.476a1.865,1.865,0,0,1,3.73,0V118.7a1.119,1.119,0,0,0,1.119,1.119h7.088a1.119,1.119,0,0,0,1.119-1.119V107.9l-2.238-1.772v11.459H139.8v-3.357a4.1,4.1,0,0,0-8.207,0v3.357h-4.85V106.124Z",
    transform: "translate(0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.320316566c456b3c2f060bccde59310b.svg";
export { ForwardRef as ReactComponent };